import { useTranslation } from 'react-i18next';

import { num } from '../../format';
import type { Consumed } from './api';

/**
 * What the print run took off the roll, in one line.
 *
 * Also what it did not take, and why. A write-off that quietly fails leaves the
 * remaining count wrong for months — the one number this whole feature exists
 * to keep honest — so the reason is said out loud where the print happened.
 *
 * Never styled as an error even when nothing was written off: the labels are
 * printed either way, and a red banner over a successful print teaches people
 * to print it again.
 */
export function ConsumedNote({ consumed }: { consumed: Consumed }) {
  const { t } = useTranslation();

  // Nothing bound is the ordinary case for most templates — a sheet of A4 has
  // no roll — so it is not worth a line.
  if (!consumed.consumed && consumed.reason === 'not_bound') return null;

  if (consumed.consumed) {
    return (
      <p className="hint">
        {t('labels.stock.spent', { n: num(consumed.quantity ?? '0') })}
        {consumed.remaining !== null &&
          ` · ${t('labels.stock.remaining', { n: num(consumed.remaining) })}`}
      </p>
    );
  }

  return (
    <p className="panel__hint">
      {t('labels.stock.notSpent')}:{' '}
      {t(`labels.stock.reasons.${consumed.reason}`, t('labels.stock.reasons.unknown'))}
    </p>
  );
}
